import { AlertIcon, Modal, useDisclosure } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { useEffect } from 'react';

export interface BrowserInterceptorProps {
  isFormDirty: boolean;
  dialogMsg?: string;
}

export const useBrowserInterceptor = ({
  isFormDirty,
  dialogMsg,
}: BrowserInterceptorProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation();

  const onConfirm = () => {
    window.history.go(-1);
  };

  const onCancel = () => {
    window.history.pushState(null, '', window.location.pathname);
    onClose();
  };

  useEffect(() => {
    const onBackButtonEvent = (e: Event) => {
      e.preventDefault();
      onOpen();
    };

    if (isFormDirty) {
      window.history.pushState(null, '', window.location.pathname);
      window.addEventListener('popstate', onBackButtonEvent);

      window.onbeforeunload = null;

      return () => {
        window.removeEventListener('popstate', onBackButtonEvent);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFormDirty]);

  const LeaveFormModal = (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={t('explorer.signUp.modal.exitForm.title')}
      text={dialogMsg ?? t('explorer.signUp.modal.exitForm.text')}
      onClickConfirm={onConfirm}
      labelBtnConfirm={t('common.confirm')}
      variantBtnConfirm="primary"
      labelBtnClose={t('common.cancel')}
      icon={AlertIcon}
      iconVariant="warning"
    />
  );

  return {
    LeaveFormModal,
  };
};
